const _excluded = ["loading", "disabled", "disableErrors", "size", "autoOk", "variant", "onChange", "highlightDay", "helperText", "skin", "format", "defaultOpen", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import { KeyboardDatePicker as MuiKeyboardDatePicker } from '@material-ui/pickers';
import cn from 'classnames';
import { format as formatDate, isSameDay } from 'date-fns';
import typography from "../../foundations/typography.module.scss";
import { DateColorful } from "../../icons";
import { useDevice } from "../Device";
import { Spinner } from "../Spinner";
import { Tooltip } from "../Tooltip";
import styles from "./InlineSelectDatePicker.module.scss";
import { inlineSelectPrimaryColor, inlineSelectStandardColor, useInlineSelectDatePickerStyles } from "./InlineSelectDatePicker.styles";
import { defaultDayHighlightSkin } from "./InlineSelectDatePicker.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function InlineSelectDatePicker(props) {
  const {
      loading,
      disabled,
      disableErrors,
      size = 'medium',
      autoOk = true,
      variant = 'inline',
      onChange: _onChange,
      highlightDay,
      helperText,
      skin = 'primary',
      format: formatProp,
      defaultOpen = false,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const isDisabled = disabled || loading;
  const inlineSelectColor = skin === 'primary' ? inlineSelectPrimaryColor : inlineSelectStandardColor;
  const {
    isMobileDevice
  } = useDevice();
  const overrides = useInlineSelectDatePickerStyles({
    isDisabled,
    inlineSelectColor,
    isMobileDevice
  });
  const disableErrorsProps = disableErrors ? {
    error: false,
    helperText: null
  } : {};
  const [open, setOpen] = useState(defaultOpen);
  const inputVariant = 'standard';
  const format = formatProp || 'MMM dd, yyyy';
  const handleFocus = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const displayValue = props.value ? formatDate(props.value, format) : '';
  const [inputWidth, setInputWidth] = useState(120);
  useEffect(() => {
    if (!displayValue) {
      setInputWidth(120);
      return;
    }
    const span = document.createElement('span');
    span.style.font = "".concat(typography.fontSizeP1, " ").concat(typography.fontFamilyBold);
    span.style.visibility = 'hidden';
    span.style.position = 'absolute';
    span.style.whiteSpace = 'pre';
    span.innerText = displayValue;
    document.body.appendChild(span);
    const width = span.getBoundingClientRect().width + 40; // padding + icon
    setInputWidth(Math.max(width, 105));
    document.body.removeChild(span);
  }, [displayValue]);
  const textField = /*#__PURE__*/_jsx(MuiKeyboardDatePicker, _objectSpread(_objectSpread(_objectSpread({}, rest), disableErrorsProps), {}, {
    "data-testid": testId,
    disabled: isDisabled,
    className: cn(rest.className, overrides.root),
    keyboardIcon: loading ? /*#__PURE__*/_jsx(Spinner, {
      size: 16,
      testId: testId && "".concat(testId, "-loading")
    }) : /*#__PURE__*/_jsx("span", {
      style: {
        display: 'inline-flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/_jsx(DateColorful, {
        style: isDisabled ? {
          opacity: 0.4
        } : undefined
      })
    }),
    autoOk: autoOk,
    format: format,
    inputVariant: inputVariant,
    variant: variant,
    focused: open,
    size: size,
    open: open,
    helperText: undefined,
    onClick: !isDisabled ? handleFocus : undefined,
    onClose: handleClose,
    KeyboardButtonProps: _objectSpread({
      'data-testid': testId && "".concat(testId, "-btn")
    }, props.KeyboardButtonProps),
    leftArrowButtonProps: _objectSpread({
      'data-testid': testId && "".concat(testId, "-prev-month")
    }, props.leftArrowButtonProps),
    rightArrowButtonProps: _objectSpread({
      'data-testid': testId && "".concat(testId, "-next-month")
    }, props.rightArrowButtonProps),
    InputLabelProps: {
      classes: {
        root: overrides.label
      }
    },
    InputProps: _objectSpread({
      disabled: isDisabled,
      readOnly: true,
      style: {
        width: inputWidth
      },
      classes: {
        root: overrides.input,
        adornedEnd: overrides.adornedEnd,
        input: cn(overrides.inputInput)
      }
    }, props.InputProps),
    inputProps: _objectSpread(_objectSpread(_objectSpread({}, displayValue ? {
      value: displayValue
    } : {}), props.inputProps), {}, {
      'data-testid': testId && "".concat(testId, "-input")
    }),
    renderDay: (day, selectedDate, dayInCurrentMonth, dayComponent) => {
      const highlighted = day && dayInCurrentMonth && highlightDay ? highlightDay(day) : false;
      const dayTestId = day && testId ? "".concat(testId, "-day-").concat(day.getMonth() + 1, "-").concat(day.getDate()) : undefined;
      return /*#__PURE__*/_jsxs("div", {
        className: styles.dayWrapper,
        "data-testid": dayTestId,
        children: [!!highlighted && !(day && selectedDate && isSameDay(day, selectedDate)) && /*#__PURE__*/_jsx("div", {
          className: cn(styles.dayHighlight, styles[typeof highlighted === 'string' ? highlighted : defaultDayHighlightSkin]),
          "data-testid": dayTestId && "".concat(dayTestId, "-highlighted")
        }), dayComponent]
      });
    },
    onChange: (date, value) => {
      const isValid = date instanceof Date && !isNaN(date.getTime());

      // We make sure Date is returned as startOfDay if valid and null if not.
      // The 3rd party component does not guarantee this.
      _onChange(isValid ? new Date(date.setHours(0, 0, 0, 0)) : null, value);
    }
  }));
  return helperText ? /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: helperText,
    testId: testId && "".concat(testId, "-tooltip"),
    children: /*#__PURE__*/_jsx("span", {
      style: {
        display: 'inline-block'
      },
      children: textField
    })
  }) : textField;
}